import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import {
  SearchPassportDto,
  CreateContactDto,
  AdministrativeData,
  MedicalInterrogation,
  Authorization,
  Prestation,
  Document,
  PaginationParams,
} from '../interfaces/passport.interface';

@Injectable({
  providedIn: 'root',
})
export class PassportService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  // Rechercher un passeport
  searchPassport(searchData: SearchPassportDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/passports/search`, searchData, {
      headers: this.getHeaders(),
    });
  }

  // Obtenir les données administratives
  getAdministrativeDatas(passportId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/passports/${passportId}/administrative_datas`,
      { headers: this.getHeaders() }
    );
  }

  // Mettre à jour les données administratives
  updateAdministrativeDatas(
    passportId: string,
    data: AdministrativeData
  ): Observable<any> {
    return this.http.put(
      `${this.baseUrl}/passports/${passportId}/administrative_datas`,
      data,
      { headers: this.getHeaders() }
    );
  }

  // Obtenir tous les types de documents
  getAllDocumentTypes(): Observable<any> {
    return this.http.get(`${this.baseUrl}/passports/document-types`, {
      headers: this.getHeaders(),
    });
  }

  // Obtenir les interrogations médicales
  getMedicalInterrogations(passportId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/passports/${passportId}/medical_interrogations`,
      { headers: this.getHeaders() }
    );
  }

  // Ajouter un contact
  addContact(
    passportId: string,
    contactData: CreateContactDto
  ): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/passports/${passportId}/contacts`,
      contactData,
      { headers: this.getHeaders() }
    );
  }

  // Obtenir les contacts
  getContacts(passportId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/passports/${passportId}/contacts`, {
      headers: this.getHeaders(),
    });
  }

  // Supprimer un contact
  deleteContact(contactId: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/passports/contacts/${contactId}`, {
      headers: this.getHeaders(),
    });
  }

  // Obtenir les autorisations
  getAuthorizations(passportId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/passports/${passportId}/authorizations`,
      { headers: this.getHeaders() }
    );
  }

  // Obtenir les prestations
  getPrestations(passportId: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/passports/${passportId}/prestations`,
      { headers: this.getHeaders() }
    );
  }

  // Obtenir les documents
  getDocuments(
    passportId: string,
    params: PaginationParams = {}
  ): Observable<any> {
    const httpParams = this.createParams(params);
    return this.http.get(`${this.baseUrl}/passports/${passportId}/documents`, {
      headers: this.getHeaders(),
      params: httpParams,
    });
  }

  // Obtenir les types de contact
  getContactTypes(): Observable<any> {
    return this.http.get(`${this.baseUrl}/passports/contact_types`, {
      headers: this.getHeaders(),
    });
  }

  // Ajouter un document
  addDocument(passportId: string, documentData: FormData): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/passports/${passportId}/documents`,
      documentData,
      { headers: this.getHeaders() }
    );
  }
}
